/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

/**
 * Identifies the different steps in the Assistant
 */
enum Steps {
  Selection = 0,
  Verification = 1,
}

export default Steps;
